import React from "react";

function PrintIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M6 0C4.34531 0 3 1.34531 3 3V7.5H6V3H16.6266L18 4.37344V7.5H21V4.37344C21 3.57656 20.6859 2.8125 20.1234 2.25L18.75 0.876563C18.1875 0.314063 17.4234 0 16.6266 0H6ZM18 16.5V18V21H6V18V17.25V16.5H18ZM21 18H22.5C23.3297 18 24 17.3297 24 16.5V12C24 10.3453 22.6547 9 21 9H3C1.34531 9 0 10.3453 0 12V16.5C0 17.3297 0.670312 18 1.5 18H3V21C3 22.6547 4.34531 24 6 24H18C19.6547 24 21 22.6547 21 21V18ZM20.25 11.625C20.5484 11.625 20.8345 11.7435 21.0455 11.9545C21.2565 12.1655 21.375 12.4516 21.375 12.75C21.375 13.0484 21.2565 13.3345 21.0455 13.5455C20.8345 13.7565 20.5484 13.875 20.25 13.875C19.9516 13.875 19.6655 13.7565 19.4545 13.5455C19.2435 13.3345 19.125 13.0484 19.125 12.75C19.125 12.4516 19.2435 12.1655 19.4545 11.9545C19.6655 11.7435 19.9516 11.625 20.25 11.625Z"
        fill="#28A745"
      />
    </svg>
  );
}

export default PrintIcon;
